if (!customElements.get('liontek-cart-addons')) {
  customElements.define('liontek-cart-addons', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.abort = new AbortController();
      this.refresh = async event => {
        if (!this.isConnected || this.dataset.enabled !== 'true' || this.busy) return;
        const revision = this.revision = (this.revision || 0) + 1;
        try {
          const cart = event?.detail?.cart || await fetch(`${Shopify.routes.root}cart.js`, {signal:this.abort.signal}).then(r => r.json());
          if (revision !== this.revision) return;
          const ids = new Set(cart.items.map(item => String(item.product_id)));
          const recommendations = new Map();
          for (const template of this.querySelectorAll('template')) {
            if (ids.has(template.dataset.source) && !ids.has(template.dataset.recommendation)) {
              if (!recommendations.has(template.dataset.recommendation)) recommendations.set(template.dataset.recommendation,template);
            }
          }
          const candidates = [...recommendations.values()].slice(0,2);
          const signature = candidates.map(template => template.dataset.recommendation).join(',');
          const host = this.querySelector('[data-addon-host]');
          if (signature !== this.signature) {
            const existing = new Map([...host.children].map(card => [card.dataset.addonProduct,card]));
            host.replaceChildren(...candidates.map(template => existing.get(template.dataset.recommendation) || template.content.cloneNode(true)));
            this.signature = signature;
            this.querySelector('[data-addon-status]').textContent = '';
          }
          this.hidden = candidates.length === 0;
        } catch (error) { if (error.name !== 'AbortError') this.hidden = true; }
      };
      this.click = async event => {
        const button = event.target.closest('[data-addon-add]');
        if (!button || button.disabled || this.busy) return;
        const card = button.closest('.liontek-addon');
        const select = card.querySelector('[data-addon-variant]');
        const id = select?.value || button.dataset.variant;
        if (!id) return;
        this.busy = true; button.disabled = true;
        const status = this.querySelector('[data-addon-status]');
        status.textContent = this.dataset.adding;
        try {
          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}]}),signal:this.abort.signal});
          const added = await response.json().catch(() => null);
          if (!response.ok || !added?.items?.length) throw new Error(added?.description || this.dataset.error);
          status.textContent = this.dataset.added;
          if (document.body.classList.contains('template-cart')) { location.reload(); return; }
          document.dispatchEvent(new CustomEvent('cart:build'));
        } catch (error) { if (error.name !== 'AbortError') status.textContent = error.message || this.dataset.error; }
        finally { this.busy = false; button.disabled = !!select && !select.value; this.refresh(); }
      };
      this.change = event => {
        if (!event.target.matches('[data-addon-variant]')) return;
        const card = event.target.closest('.liontek-addon');
        card.querySelector('[data-addon-add]').disabled = !event.target.value;
        const selected = event.target.selectedOptions[0];
        if (selected.dataset.price) card.querySelector('[data-addon-price]').textContent = selected.dataset.price;
      };
      const target = document.querySelector('.template-cart .cart__page') || document.querySelector('#CartDrawer .drawer__scrollable');
      if (!target) return;
      this.addEventListener('click',this.click);
      this.addEventListener('change',this.change);
      for (const event of ['ajaxProduct:added','cart:updated','cart:open']) document.addEventListener(event,this.refresh);
      this.refresh();
      this.bindPreview = () => {
        const preview = document.getElementById('PBarNextFrameWrapper');
        if (!preview || this.previewResize) return;
        this.previewWait?.disconnect();
        this.previewResize = new ResizeObserver(() => document.documentElement.style.setProperty('--liontek-preview-inset',`${Math.max(0,preview.getBoundingClientRect().height)}px`));
        this.previewResize.observe(preview);
      };
      if (window.Shopify?.theme?.role !== 'main') {
        this.previewWait = new MutationObserver(this.bindPreview);
        this.previewWait.observe(document.body,{childList:true});this.bindPreview();
      }
      // Move the section wrapper with its editor identity; reconnect only after the move completes.
      const wrapper = this.closest('.shopify-section');
      if (wrapper && wrapper.parentElement !== target) {
        this.moving = true; target.append(wrapper); this.moving = false;
      }
    }
    disconnectedCallback() {
      if (this.moving) return;
      this.abort?.abort();this.previewWait?.disconnect();this.previewResize?.disconnect();
      for (const event of ['ajaxProduct:added','cart:updated','cart:open']) document.removeEventListener(event,this.refresh);
      this.removeEventListener('click',this.click);this.removeEventListener('change',this.change);
      this.started = false;
    }
  });
}
